import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'turkish-lira',
  size: 24,
  node: [
    ['path', { d: 'm14 10-8 4', key: 'q2jxyq' }],
    ['path', { d: 'M14 5 6 9', key: '3luqa0' }],
    ['path', { d: 'M18 12a8 8 0 01-7.003 7.937c-.547.07-.997-.385-.997-.937V4', key: '18c6as' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name TurkishLira
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQgMTAtOCA0IiAvPgogIDxwYXRoIGQ9Ik0xNCA1IDYgOSIgLz4KICA8cGF0aCBkPSJNMTggMTJhOCA4IDAgMDEtNy4wMDMgNy45MzdjLS41NDcuMDctLjk5Ny0uMzg1LS45OTctLjkzN1Y0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/turkish-lira
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurkishLira = createLucideIcon(__iconData);

export default TurkishLira;
